import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChatPersonalization } from '../../../domain/chat/models/ChatPersonalization';
import {
    ChatPersonalizationState,
    initialChatPersonalizationState,
} from './chatPersonalizationState';
import { SavedPrompt } from '../../../domain/chat/models/SavedPrompt';
import { SavedPersona } from '../../../domain/chat/models/SavedPersona';

const chatPersonalizationSlice = createSlice({
    name: 'chatPersonalization',
    initialState: initialChatPersonalizationState,
    reducers: {
        setChatPersonalization: (
            state: ChatPersonalizationState,
            action: PayloadAction<ChatPersonalization>,
        ) => {
            state.userId = action.payload.userId;
            state.personas = action.payload.personas;
            state.prompts = action.payload.prompts;
            state.isLoaded = true;
        },
        upsertSavedPersona: (state: ChatPersonalizationState, action: PayloadAction<SavedPersona>) => {
            const persona = action.payload;
            const existingIndex = state.personas.findIndex((item) => item.id === persona.id);

            if (existingIndex >= 0) {
                state.personas[existingIndex] = persona;
                return;
            }

            state.personas.unshift(persona);
        },
        removeSavedPersona: (state: ChatPersonalizationState, action: PayloadAction<string>) => {
            state.personas = state.personas.filter((persona) => persona.id !== action.payload);
        },
        upsertSavedPrompt: (state: ChatPersonalizationState, action: PayloadAction<SavedPrompt>) => {
            const prompt = action.payload;
            const existingIndex = state.prompts.findIndex((item) => item.id === prompt.id);

            if (existingIndex >= 0) {
                state.prompts[existingIndex] = prompt;
                return;
            }

            state.prompts.unshift(prompt);
        },
        removeSavedPrompt: (state: ChatPersonalizationState, action: PayloadAction<string>) => {
            state.prompts = state.prompts.filter((prompt) => prompt.id !== action.payload);
        },
        clearChatPersonalization: (state: ChatPersonalizationState) => {
            state.userId = null;
            state.personas = [];
            state.prompts = [];
            state.isLoaded = false;
        },
    },
});

export const {
    setChatPersonalization,
    upsertSavedPersona,
    removeSavedPersona,
    upsertSavedPrompt,
    removeSavedPrompt,
    clearChatPersonalization,
} = chatPersonalizationSlice.actions;

export default chatPersonalizationSlice.reducer;
